import '@vaadin/number-field';
import { componentName, NumberFieldClass } from './NumberFieldClass';

customElements.define(componentName, NumberFieldClass);

export { NumberFieldClass, componentName };
